import { combineReducers } from 'redux'
import ui from './ui'
import session from './session'

// import { routerReducer } from 'react-router-redux'

const reducer = combineReducers({ ui, session })

export default reducer